module.exports = __webpack_public_path__ + "img/img_qywx.0b33c3de.png";